module.exports = __webpack_public_path__ + "static/media/2.8307b799.jpg";